import styled from 'styled-components';
import { palette } from 'styled-theme';

export const StyledCheckboxWrapper = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  color: ${palette('background', 0)};
  position: relative;
  line-height: 1.5715;
  gap: 8px;

  .ant-checkbox {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    min-width: 16px;
    border: 1px solid ${({ theme }) => (theme.name === 'atsFancy' ? '#d9d9d9' : '#fff')};
    border-radius: 2px;
    background-color: ${({ theme }) =>
      theme.name === 'atsFancy' ? '#fff' : 'rgba(255, 255, 255, 0.5)'};
    transition: all 0.2s;

    input {
      position: absolute;
      inset: 0;
      opacity: 0;
      cursor: pointer;
      z-index: 1;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
    }

    &::after {
      content: '';
      box-sizing: border-box;
      position: absolute;
      top: 46%;
      left: 20%;
      width: 5.5px;
      height: 9px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(0) translate(-50%, -50%);
      opacity: 0;
      transition:
        all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),
        opacity 0.1s;
    }
  }

  .ant-checkbox-label {
    display: inline-flex;
    align-items: center;
    line-height: normal;
  }

  /* Checked */
  &.ant-checkbox-wrapper-checked {
    .ant-checkbox {
      background-color: ${palette('primary', 0)};
      border-color: ${palette('primary', 0)};

      &::after {
        opacity: 1;
        transform: rotate(45deg) scale(1) translate(-50%, -50%);
        transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
      }
    }
  }

  /* Indeterminate */
  &.ant-checkbox-wrapper-indeterminate {
    .ant-checkbox {
      background-color: ${palette('primary', 0)};
      border-color: ${palette('primary', 0)};

      &::after {
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        border: 0;
        background-color: #fff;
        border-radius: 1px;
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }

  /* Disabled */
  &.ant-checkbox-wrapper-disabled {
    cursor: not-allowed;

    .ant-checkbox {
      background-color: #ccc;
      border-color: #ccc;
      cursor: not-allowed;

      input {
        cursor: not-allowed;
      }

      &::after {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    .ant-checkbox-label {
      color: ${({ theme }) =>
        theme.name === 'atsFancy' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(255, 255, 255, 0.5)'};
      cursor: not-allowed;
    }
  }

  /* Hover / Focus (not disabled) */
  &:not(.ant-checkbox-wrapper-disabled) {
    &:hover,
    &:focus-within {
      .ant-checkbox {
        border-color: ${palette('primary', 0)};
      }
    }
  }
`;

export const StyledCheckboxGroup = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;

  > * {
    margin-right: 22px;
  }
`;

export const GroupWrapper = styled.span<{ $vertical?: boolean }>`
  display: ${({ $vertical }) => ($vertical ? 'flex' : 'inline')};
  flex-direction: column;
  margin-top: 8px;
  gap: 8px;

  .ant-checkbox-group {
    display: ${({ $vertical }) => ($vertical ? 'flex' : 'inline-block')};
    flex-direction: column;
    gap: 13px;
  }

  .ant-checkbox-wrapper {
    font-size: 13px;
    color: ${palette('background', 0)};
    margin-right: 8px;

    &.ant-checkbox-wrapper-disabled {
      .ant-checkbox {
        background-color: #ccc;
        border-color: #ccc;
      }
    }
  }
`;
